export default {
  //----------------------------------
  // Header
  //----------------------------------
  header: {
    artist: {
      firstname: 'Gianin',
      lastname: 'Conrad',
    },
    navigation: [
      // { label: 'Aktuelles', slug: 'news' },
      { label: 'Works', slug: 'objects' },
      { label: 'Projects', slug: 'projects' },
      { label: 'Exhibitions', slug: 'exhibits' },
      { label: 'CV', slug: 'cv' },
      { label: 'Texts', slug: 'texts' },
      // { label: 'Videos', slug: 'videos' },
      { label: 'Contact', slug: 'contact' },
    ],
  },

  //----------------------------------
  // Labels
  //----------------------------------
  labels: {
    more: 'more',
  },

  //----------------------------------
  // Contactform
  //----------------------------------
  contactform: {
    title: 'Get in contact',
    firstname: 'First name *',
    lastname: 'Last name *',
    email: 'Email address *',
    message: 'Your message',
    submit: 'Send',
    thankyou: {
      title: 'Thank you!',
      body: 'I\'ll get back to you as soon as possible.',
    },
  },

  //----------------------------------
  // Footer
  //----------------------------------
  footer: {
    address: 'Gianin Conrad<br/>Birmensdorferstrasse 13<br/>8004 Zürich<br/>Switzerland',
    contacts: [
      { label: '079 698 04 24', url: 'tel:0041796980424' },
      { label: 'gianin.conrad@gmx.ch', url: 'mailto:gianin.conrad@gmx.ch' },
    ],
    socials: [
      { channel: 'instagram', label: 'Instagram', url: 'https://www.instagram.com/gianinconrad' },
      { channel: 'facebook', label: 'Facebook', url: 'https://www.facebook.com/gianin.conrad/' },
      // { channel: 'youtube', label: 'Youtube', url: 'https://www.youtube.com' },
      // { channel: 'twitter', label: 'Twitter', url: 'https://twitter.com' },
    ],
  },

  //----------------------------------
  // Globals
  //----------------------------------
  contact_email: 'gianin.conrad@gmx.ch',
};
